import { measurementVisualizationTableRowProps } from '@redux/slices/measurementVisualizationSlice';
import dayjs from 'dayjs';

export type TsosStateProps = {
  id: number;
  name: string;
  active: boolean;
  abbreviation: string;
};

export const generateFileName = (row: measurementVisualizationTableRowProps) => {
  return `${row.measurementDevice}_${row.aggregationIntervalType}_${row.start.replace(' ', 'T')}-${row.end.replace(' ', 'T')}.csv`;
};

export const downloadCsvFile = (response: string, row: measurementVisualizationTableRowProps) => {
  const csv = response ?? '';
  const blob = new Blob([csv], { type: 'text/csv;charset=utf=8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.download = generateFileName(row);
  a.href = url;
  a.click();
  URL.revokeObjectURL(url);
};

export const downloadExcelFile = (response: Blob, name: string, start?: string, end?: string) => {
  const url = URL.createObjectURL(response);
  const anchor = document.createElement('a');
  const startDate = start ? `_${start}` : '';
  const endDate = end ? `-${end}` : '';
  anchor.download = `${name}${startDate}${endDate}.xlsx`;
  anchor.href = url;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

export const csvParams = (row: measurementVisualizationTableRowProps) => {
  return {
    from: dayjs(row.start).format('YYYY-MM-DDTHH:mm:ss'),
    to: dayjs(row.end).format('YYYY-MM-DDTHH:mm:ss'),
    measurementDeviceTechnicalName: row.measurementDeviceTechnicalName,
    aggregationInterval: row.aggregationIntervalType,
    tsoId: row.tsoId,
    body: row.usedParameters.map((parameter: { value: any }) => parameter.value),
  };
};

export const findDiff = ({
  activeTsos,
  prevActiveTsosRef,
}: {
  activeTsos: TsosStateProps[];
  prevActiveTsosRef: React.MutableRefObject<TsosStateProps[]>;
}) => {
  const diff = [
    ...activeTsos.filter((tso) => !prevActiveTsosRef.current.some((prevTso: { id: number }) => tso.id === prevTso.id)),
    ...prevActiveTsosRef.current.filter((prevTso: { id: number }) => !activeTsos.some((tso) => prevTso.id === tso.id)),
  ];
  return diff;
};
